import { notificationsApi } from 'api/notifications/notifications.api';
import { readDraft, readSettings } from 'redux/selectors/notificationSettings';
import type { Thunk } from 'types/redux';
import type { NotificationAndReminderSettings } from './notificationSettings.types';
import {
  fetchedNotificationSettings,
  savedDraft,
  wrapFetching,
  wrapSaving,
} from './notificationSettings.types';

export {
  clearDraft,
  fetchedNotificationSettings,
  savedDraft,
  startDraft,
  updateDraft,
} from './notificationSettings.types';

export const fetchNotificationSettings = (): Thunk => async dispatch => {
  const response: NotificationAndReminderSettings = await dispatch(
    wrapFetching(notificationsApi.getNotificationSettings())
  );

  dispatch(fetchedNotificationSettings(response));
  return response;
};

export const saveDraft = (): Thunk => async (dispatch, getState) => {
  const state = getState();
  const current = readSettings(state);
  const draft = readDraft(state);

  if (!draft) {
    return current;
  }

  const response: NotificationAndReminderSettings = await dispatch(
    wrapSaving(notificationsApi.saveNotificationSettings(draft))
  );

  dispatch(savedDraft(response));

  return response;
};
